<template>
  <div class="wg-row">
    <!-- VARIATION MODAL -->
    <wg-modal 
        :width="windowWidth > 900 ? '900px' : '90%'" 
        v-if="showVariationsDialog" 
        @closeModal="showVariationsDialog = false">
      <div class="com-anm22-app-text-xl" slot="header">
        {{ $anm22.strLang(lang, 'Variations', 'Variazioni')}}
      </div>
      <div class="wg-row" slot="body">
        <div class="wg-row">
          <div class="wg-col wg-xs-12 wg-sm-6" style="padding:0 10px 0 0;">
            <div class="wg-row" style="justify-content:center;">
              <div class="com-anm22-app-text-xl" style="padding:0 2px;">
                {{ $anm22.strLang(lang, 'List', 'Lista') }}
              </div>
            </div>
            <div class="vertical-height-div" style="height:10px;"></div>
            <div 
                v-for="(v,i) in productRef.variations"
                :key="'cat-var-'+i"
                class="wg-row"
                style="flex-wrap:nowrap;align-items:center;margin-bottom:10px;height:36px;">
              <img 
                  :src="$anm22.icons.getWorldIcon('deleteBlack')"
                  class="com-anm22-app-img-fixed-height-m" 
                  @click="deleteVariation(i)"
                  style="margin-right:10px;cursor:pointer;"
              >
              <div class="com-anm22-app-text-l">
                {{ 
                  v.it + (v.en ? (', ' + v.en) : '')+ (v.de ? (', ' + v.de) : '') + (v.fr ? (', ' + v.fr) : '')
                    + (v.es ? (', ' + v.es) : '') + (v.ru ? (', ' + v.ru) : '')
                }}
                {{ (typeof v.code != 'undefined' && v.code != '') ? '[' + v.code + ']' : '' }}
              </div>
              <div class="com-anm22-app-text-l" style="margin-left:auto;">
                {{ v.price.toFixed(2) + ' €'}}
              </div>
            </div>
          </div>
          <div class="wg-col wg-xs-12 wg-sm-6" style="padding:0 0 0 10px;">
            <div class="wg-row" style="justify-content:center;">
              <div class="com-anm22-app-text-xl" style="padding:0 2px;">
                {{ $anm22.strLang(lang, 'New', 'Nuova') }}
              </div>
            </div>
            <template v-if="varError">
              <div class="vertical-height-div" style="height:10px;"></div>
              <div class="wg-row com-anm22-app-text-m" style="color:red;">
                {{ varError }}
              </div>
            </template>
            <div class="vertical-height-div" style="height:10px;"></div>
            <div class="wg-row" style="flex-wrap:nowrap;align-items:center;justify-content:space-between;">
              <div class="com-anm22-app-text-l">
                {{ $anm22.strLang(lang, 'Code', 'Codice') }}
              </div>
              <input 
                  class="com-anm22-app-input-text"
                  style="max-width:70%;"
                  type="text"
                  :placeholder="$anm22.strLang(lang, 'Article code', 'Codice articolo')"
                  v-model="variation.code"> 
            </div>
            <div class="vertical-height-div" style="height:10px;"></div>
            <div class="wg-row" style="flex-wrap:nowrap;align-items:center;justify-content:space-between;">
              <div class="com-anm22-app-text-l">
                {{ $anm22.strLang(lang, 'Text', 'Testo') + ' IT' }}
              </div>
              <input 
                  class="com-anm22-app-input-text"
                  style="max-width:70%;"
                  type="text"
                  :placeholder="$anm22.strLang(lang, 'Text', 'Testo')"
                  v-model="variation.it"> 
            </div>
            <div class="vertical-height-div" style="height:10px;"></div>
            <div class="wg-row" style="flex-wrap:nowrap;align-items:center;justify-content:space-between;">
              <div class="com-anm22-app-text-l">
                {{ $anm22.strLang(lang, 'Text', 'Testo') + ' EN' }}
              </div>
              <input 
                  class="com-anm22-app-input-text"
                  style="max-width:70%;"
                  type="text"
                  :placeholder="$anm22.strLang(lang, 'Text', 'Testo')"
                  v-model="variation.en"> 
            </div>
            <div class="vertical-height-div" style="height:10px;"></div>
            <div class="wg-row" style="flex-wrap:nowrap;align-items:center;justify-content:space-between;">
              <div class="com-anm22-app-text-l">
                {{ $anm22.strLang(lang, 'Text', 'Testo') + ' DE' }}
              </div>
              <input 
                  class="com-anm22-app-input-text"
                  style="max-width:70%;"
                  type="text"
                  :placeholder="$anm22.strLang(lang, 'Text', 'Testo')"
                  v-model="variation.de"> 
            </div>
            <div class="vertical-height-div" style="height:10px;"></div>
            <div class="wg-row" style="flex-wrap:nowrap;align-items:center;justify-content:space-between;">
              <div class="com-anm22-app-text-l">
                {{ $anm22.strLang(lang, 'Text', 'Testo') + ' FR' }}
              </div>
              <input 
                  class="com-anm22-app-input-text"
                  style="max-width:70%;"
                  type="text"
                  :placeholder="$anm22.strLang(lang, 'Text', 'Testo')"
                  v-model="variation.fr"> 
            </div>
            <div class="vertical-height-div" style="height:10px;"></div>
            <div class="wg-row" style="flex-wrap:nowrap;align-items:center;justify-content:space-between;">
              <div class="com-anm22-app-text-l">
                {{ $anm22.strLang(lang, 'Text', 'Testo') + ' ES' }}
              </div>
              <input 
                  class="com-anm22-app-input-text"
                  style="max-width:70%;"
                  type="text"
                  :placeholder="$anm22.strLang(lang, 'Text', 'Testo')"
                  v-model="variation.es"> 
            </div>
            <div class="vertical-height-div" style="height:10px;"></div>
            <div class="wg-row" style="flex-wrap:nowrap;align-items:center;justify-content:space-between;">
              <div class="com-anm22-app-text-l">
                {{ $anm22.strLang(lang, 'Text', 'Testo') + ' RU' }}
              </div>
              <input 
                  class="com-anm22-app-input-text"
                  style="max-width:70%;"
                  type="text"
                  :placeholder="$anm22.strLang(lang, 'Text', 'Testo')"
                  v-model="variation.ru"> 
            </div>
            <div class="vertical-height-div" style="height:10px;"></div>
            <div class="wg-row" style="flex-wrap:nowrap;align-items:center;justify-content:space-between;">
              <div class="com-anm22-app-text-l">
                {{ $anm22.strLang(lang, 'Price', 'Prezzo') + ' [€]' }}
              </div>
              <input 
                  class="com-anm22-app-input-number"
                  style="max-width:100px;"
                  type="number"
                  :placeholder="$anm22.strLang(lang, 'Price', 'Prezzo')"
                  v-model.number="variation.price">   
            </div>
            <div class="vertical-height-div" style="height:10px;"></div>
            <div class="wg-row" style="justify-content:center;">
            <input 
                type="button" 
                :value="$anm22.strLang(lang, 'Add', 'Aggiungi')" 
                @click="addVariation">
            </div>
          </div>
        </div>
      </div>
    </wg-modal>
    <!-- Modale conferma cancellazione immagine -->
    <wg-modal v-if="showConfirmDelete" @closeModal="showConfirmDelete = false">
      <div slot="body">
        <div class="vertical-height-div" style="height:20px;"></div>
        <div class="com-anm22-app-text-xxl">
          {{ $anm22.strLang(lang, 'Delete this product\'s image','Eliminare l\'immagine di questo prodotto?') }}
        </div>
        <div class="vertical-height-div" style="height:20px;"></div>
        <div class="wg-row" style="align-items:center;justify-content:flex-end;">
          <div 
              class="com-anm22-app-text-xl" 
              style="cursor:pointer;color:#f00;font-weight:bold;" 
              @click="deleteImage">
            {{ $anm22.strLang(lang, 'CONFIRM', 'CONFERMA') }}
          </div>
        </div>
      </div>
    </wg-modal>
    <!-- ICON MODAL -->
    <wg-modal 
        :width="windowWidth > 600 ? '600px' : '90%'" 
        v-if="showIconDialog" 
        @closeModal="showIconDialog = false">
      <div class="com-anm22-app-text-xl" slot="header">
        {{ $anm22.strLang(lang, 'Choose icon', 'Seleziona icona')}}
      </div>
      <div class="wg-row" slot="body" :style="{height: ((windowHeight / 100 * 90) - 90) + 'px', justifyContent: 'center'}">
        <div class="wg-row com-anm22-app-text-xl" style="justify-content:center;">
          {{ $anm22.strLang(lang, 'Upload a picture', 'Carica una foto') }}
        </div>
        <div class="vertical-height-div" style="height:10px;"></div>
        <!-- File uploader -->
        <div class="wg-row" style="justify-content:center;">
          <!-- current image for product -->
          <div v-if="productRef.image" style="position:relative;height:100px;width:100px;margin:5px;">
            <img 
              style="height:100%;width:100%;cursor:default"
              :src="$anm22.getImagePath(productRef.image)">
            <img 
              v-if="!isOffline"
              class="com-anm22-app-img-fixed-height-m"
              style="position:absolute;top:3px;right:3px;cursor:pointer;"
              :src="$anm22.icons.getWorldIcon('deleteBin')"
              @click="showConfirmDelete = true">
          </div>
          <anm22-file-uploader
            :uploadUrl="'inventory/upload-image'"
            :allowedExtensions="['jpg','jpeg','png','svg']"
            :onSuccess="setImage"
          ></anm22-file-uploader>
        </div>
        <div class="vertical-height-div" style="height:10px;"></div>
        <div class="wg-row com-anm22-app-text-xl" style="justify-content:center;">
          {{ $anm22.strLang(lang, 'Or choose an icon from the list', 'Oppure scegli un\'icona dalla lista') }}
        </div>
        <div class="vertical-height-div" style="height:10px;"></div>
        <!-- Lista icone -->
        <div class="wg-row com-anm22-food-scrolling-panel" style="height:calc(100% - 230px);justify-content:center;">
          <div 
              v-for="(url,name,i) in icons"
              :key="'icon-'+i"
              :class="['icon-div', icon === name ? 'selected' : '']"
              @click="setIcon(name)">
            <img class="com-anm22-app-img-l" :src="$anm22.getImagePath(url)">
          </div>
        </div>
        <div class="vertical-height-div" style="height:10px;"></div>
        <div class="wg-row" style="justify-content:center;">
          <input 
              type="button" 
              :value="$anm22.strLang(lang, 'Confirm', 'Conferma')" 
              @click="showIconDialog = false;">
        </div>
      </div>
    </wg-modal>
    <!-- COLOR MODAL -->
    <wg-modal 
        :width="windowWidth > 400 ? '400px' : '90%'" 
        v-if="showColorDialog" 
        @closeModal="showColorDialog = false">
      <div class="com-anm22-app-text-xl" slot="header">
        {{ $anm22.strLang(lang, 'Choose color', 'Seleziona colore')}}
      </div>
      <div class="wg-row" slot="body">
        <!-- Lista colori -->
        <div 
            v-for="(col, i) in colors"
            :key="'color-'+i"
            :class="['wg-row', 'color-div', col === color ? 'selected' : '']"
            @click="color = col">
          <div :style="{backgroundColor: col}"></div>
        </div>
        <div class="wg-row" style="justify-content:center;">
          <input 
              type="button" 
              :value="$anm22.strLang(lang, 'Confirm', 'Conferma')" 
              @click="setColor">
        </div>
      </div>
    </wg-modal>
    <!-- LOGS MODAL -->
    <wg-modal 
        :width="windowWidth > 600 ? '600px' : '90%'" 
        v-if="showInventoryLogsDialog" 
        @closeModal="showInventoryLogsDialog = false">
      <div class="com-anm22-app-text-xl" slot="header">
        {{ $anm22.strLang(lang, 'Inventory logs', 'Movimenti inventario')}}
      </div>
      <div class="wg-row" slot="body">
        <div class="wg-row" style="margin-bottom:10px;">
          <div class="com-anm22-app-text-m" style="color:#999;">
            {{ $anm22.strLang(lang, '*Detailed logs available starting 22/06/2021', '*Log dettagliati disponibili a partire dal 22/06/2021') }}
          </div>
        </div>
        <div class="wg-row" v-if="entriesListRows.length > 0" :style="{height: (listHeight - 60) + 'px'}">
          <!-- Lista log -->
          <w-g-list
              :pagination="true"
              :fieldInit="'id'"
              :keyField="'id'"
              :headerItems="entriesListHeader"
              :itemsToDisplay="entriesListRows"
          >
            <template v-slot:default="{ element }">
              <div class="wg-row item-row" style="margin: 5px 0;">
                <div class="wg-col wg-xs-4" style="padding: 10px 0;">
                  <div class="wg-row" style="flex-wrap:nowrap;align-items:center;">
                    <div class="com-anm22-app-text-l">
                      {{ element.ts ? $moment.tz(element.ts, 'X', timezone).format('LLL') : '' }}
                    </div>
                  </div>
                </div>
                <div class="wg-col wg-xs-5" style="padding: 10px 0;">
                  <div class="wg-row" style="flex-wrap:nowrap;align-items:center;">
                    <div class="com-anm22-app-text-l">
                      {{ element.log ? $anm22.strLang(lang, 'Load', 'Distinta') : $anm22.strLang(lang, 'Order', 'Ordine') }}
                    </div>
                  </div>
                </div>
                <div class="wg-col wg-xs-3" style="padding: 10px 0;">
                  <div class="wg-row" style="flex-wrap:nowrap;align-items:center;justify-content:flex-end;">
                    <div class="com-anm22-app-text-l">
                      {{ element.variation + ' ' + getUom(element) }}
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </w-g-list>
        </div>
        <div v-else class="com-anm22-app-text-xl">
          {{ $anm22.strLang(lang, 'No logs', 'Nessun movimento')}}
        </div>
      </div>
    </wg-modal>
    <!-- Tasti modali secondari -->
    <div v-if="productRef.id"  class="wg-row" style="flex-wrap:nowrap;align-items:center;justify-content:space-around;">
      <input 
          type="button" 
          :value="$anm22.strLang(lang, 'Variations', 'Variazioni')" 
          @click="showVariationsDialog = true">
      <input 
          type="button" 
          :value="$anm22.strLang(lang, 'Icon', 'Icona')" 
          @click="openIconModal">
      <input 
          type="button" 
          :value="$anm22.strLang(lang, 'Color', 'Colore')" 
          @click="openColorModal">
    </div>
    <div class="vertical-height-div" style="height:10px;"></div>
    <div class="wg-row">
      <div class="com-anm22-app-text-l" style="padding:0 2px;">
        {{ $anm22.strLang(lang, 'Name', 'Nome') }}
      </div>
      <div class="vertical-height-div" style="height:5px;"></div>
      <input 
          class="com-anm22-app-input-text"
          style="max-width:100%;"
          type="text"
          :placeholder="$anm22.strLang(lang, 'Name', 'Nome')"
          v-model="product.name">   
    </div>
    <div class="vertical-height-div" style="height:10px;"></div>
    <div class="wg-row">
      <div class="wg-col wg-xs-12 wg-sm-6" style="padding:0 5px 0 0;">
        <div class="com-anm22-app-text-l" style="padding:0 2px;">
          {{ $anm22.strLang(lang, 'Product code', 'Codice prodotto') }}
        </div>
        <div class="vertical-height-div" style="height:5px;"></div>
        <input 
            class="com-anm22-app-input-text"
            style="max-width:100%;"
            type="text"
            :placeholder="$anm22.strLang(lang, 'Product code', 'Codice prodotto')"
            v-model="product.code">   
      </div>
    </div>
    <div class="vertical-height-div" style="height:10px;"></div>
    <div class="wg-row">
      <div class="wg-col wg-xs-12 wg-sm-6" style="padding:0 5px 0 0;">
        <div class="com-anm22-app-text-l" style="padding:0 2px;">
          {{ $anm22.strLang(lang, 'Category', 'Categoria') }}
        </div>
        <div class="vertical-height-div" style="height:5px;"></div>
        <select class="com-anm22-app-select" v-model="product.category" style="max-width:100%;">
          <option default disabled value="">{{ $anm22.strLang(lang, 'Select one', 'Seleziona...') }}</option>
          <option 
              v-for="(c,i) in categories"
              :key="'cat-'+i"
              :value="c.id">
            {{ c.langName }}
          </option>
        </select>
      </div>
    </div>
    <div class="vertical-height-div" style="height:10px;"></div>
    <div class="wg-row">
      <div class="wg-col wg-xs-12 wg-sm-6" style="padding:0 5px 0 0;">
        <div class="com-anm22-app-text-l" style="padding:0 2px;">
          {{ $anm22.strLang(lang, 'Highlight', 'In evidenza') }}
        </div>
        <div class="vertical-height-div" style="height:5px;"></div>
        <input 
            id="pinToTop"
            type="checkbox"
            :value="0"
            style="display:none;"
            v-model="product.pinToTop">
        <label class="label-input-radio" for="pinToTop">
          {{ product.pinToTop ? '✔' : '' }}
        </label>
      </div>
    </div>
    <div class="vertical-height-div" style="height:10px;"></div>
    <!-- PRICING -->
    <!-- Pricing type -->
    <div class="wg-row">
      <div class="wg-col wg-xs-12 wg-sm-6" style="padding:0 5px 0 0;">
        <div class="com-anm22-app-text-l" style="padding:0 2px;">
          {{ $anm22.strLang(lang, 'Pricing type', 'Tipo tariffazione') }}
        </div>
        <div class="vertical-height-div" style="height:5px;"></div>
        <select class="com-anm22-app-select" v-model.number="product.pricingType" style="max-width:100%;">
          <option 
              v-for="(obj,key,i) in $anm22.tableClasses.foodProductPricingType().getAll()"
              :key="'prod-p-type-'+i"
              :value="key">
            {{ obj[lang] }}
          </option>
        </select>
      </div>
    </div>
    <template v-if="product.pricingType === 2 && product.stockType !== 3">
      <div class="vertical-height-div" style="height:10px;"></div>
      <!-- Unit of measure (if weight) -->
      <div class="wg-row">
        <div class="wg-col wg-xs-12 wg-sm-6" style="padding:0 5px 0 0;">
          <div class="com-anm22-app-text-l" style="padding:0 2px;">
            {{ $anm22.strLang(lang, 'Unit of measurement', 'Unità di misura') }}
          </div>
          <template v-if="uomError">
            <div class="vertical-height-div" style="height:5px;"></div>
            <div class="wg-row com-anm22-app-text-m" style="color:red;">
              {{ uomError }}
            </div>
          </template>
          <div class="vertical-height-div" style="height:5px;"></div>
          <select 
              class="com-anm22-app-select"
              @change="uomError = ''"
              v-model.number="product.uom" 
              style="max-width:100%;">
            <option disabled value="">{{ $anm22.strLang(lang, 'Select', 'Seleziona') }}</option>
            <option 
                v-for="(obj,key,i) in $anm22.tableClasses.foodUnitOfMeasurement().getAll()"
                :key="'prod-uof-'+i"
                :value="key"
                @change="uomError = ''">
              {{ obj[lang] }}
            </option>
          </select>
        </div>
      </div>
      <div class="vertical-height-div" style="height:10px;"></div>
      <!-- Standard weight (if weight) -->
      <div class="wg-row">
        <div class="wg-col wg-xs-12 wg-sm-6" style="padding:0 5px 0 0;">
          <div class="com-anm22-app-text-l" style="padding:0 2px;">
            {{ $anm22.strLang(lang, 'Standard portion', 'Porzione standard') }}
          </div>
          <div class="vertical-height-div" style="height:5px;"></div>
          <input 
              style="max-width:100%;"
              type="number"
              :placeholder="$anm22.strLang(lang, 'Quantity', 'Quantità')"
              v-model="product.defaultQuantity">   
        </div>
      </div>
    </template>
    <!-- Price -->
    <div class="vertical-height-div" style="height:10px;"></div>
    <div class="wg-row">
      <div class="wg-col wg-xs-12 wg-sm-6" style="padding:0 5px 0 0;">
        <div class="com-anm22-app-text-l" style="padding:0 2px;">
          {{ $anm22.strLang(lang, 'Price with VAT', 'Prezzo con IVA') }}
        </div>
        <template v-if="priceError">
          <div class="vertical-height-div" style="height:5px;"></div>
          <div class="wg-row com-anm22-app-text-m" style="color:red;">
            {{ priceError }}
          </div>
        </template>
        <div class="vertical-height-div" style="height:5px;"></div>
        <input 
            :class="product.price < 0 ? 'error' : ''"
            style="max-width:100%;"
            type="number"
            min="0"
            value="0"
            step="0.01"
            :placeholder="$anm22.strLang(lang, 'Price with VAT', 'Prezzo con IVA')"
            @input="priceError = ''"
            v-model.number="product.price">   
      </div>
    </div>
    <div class="vertical-height-div" style="height:10px;"></div>
    <div class="wg-row">
      <div class="wg-col wg-xs-12 wg-sm-6" style="padding:0 5px 0 0;">
        <div class="com-anm22-app-text-l" style="padding:0 2px;">
          {{ $anm22.strLang(lang, 'VAT', 'IVA') }}
        </div>
        <div class="vertical-height-div" style="height:5px;"></div>
        <input 
            class="com-anm22-app-input-number"
            style="max-width:100%;"
            type="number"
            min="0"
            step="0.01"
            :placeholder="$anm22.strLang(lang, 'VAT', 'IVA')"
            v-model.number="product.vat">  
      </div>
    </div>
    <div class="vertical-height-div" style="height:10px;"></div>
    <div class="wg-row">
      <div class="wg-col wg-xs-12 wg-sm-6" style="padding:0 5px 0 0;">
        <div class="com-anm22-app-text-l" style="padding:0 2px;">
          {{ $anm22.strLang(lang, 'Stock type', 'Tipologia stoccaggio') }}
        </div>
        <div class="vertical-height-div" style="height:5px;"></div>
        <select class="com-anm22-app-select" v-model.number="product.stockType" style="max-width:100%;">
          <option 
              v-for="(obj,key,i) in $anm22.tableClasses.foodProductStockType().getAll()"
              :key="'prod-stock-type-'+i"
              :value="key">
            {{ obj[lang] }}
          </option>
        </select>
      </div>
    </div>
    <template v-if="product.stockType !== 1">
      <div class="vertical-height-div" style="height:10px;"></div>
      <div class="wg-row">
        <div class="wg-col wg-xs-12 wg-sm-6" style="padding:0 5px 0 0;">
          <div class="com-anm22-app-text-l" style="padding:0 2px;">
            {{ $anm22.strLang(lang, 'Quantity', 'Quantità') }}
          </div>
          <div class="vertical-height-div" style="height:5px;"></div>
          <input 
              class="com-anm22-app-input-number"
              style="max-width:100%;"
              type="number"
              :placeholder="$anm22.strLang(lang, 'Quantity', 'Quantità')"
              :value="product.quantity"
              @change="changeQuantity('quantity', $event.target.value)">  
        </div>
      </div>
      <template v-if="product.stockType === 3">
        <div class="vertical-height-div" style="height:10px;"></div>
        <!-- Unit of measure (if weight) -->
        <div class="wg-row">
          <div class="wg-col wg-xs-12 wg-sm-6" style="padding:0 5px 0 0;">
            <div class="com-anm22-app-text-l" style="padding:0 2px;">
              {{ $anm22.strLang(lang, 'Unit of measurement', 'Unità di misura') }}
            </div>
            <template v-if="uomError">
              <div class="vertical-height-div" style="height:5px;"></div>
              <div class="wg-row com-anm22-app-text-m" style="color:red;">
                {{ uomError }}
              </div>
            </template>
            <div class="vertical-height-div" style="height:5px;"></div>
            <select 
                class="com-anm22-app-select"
                @change="uomError = ''"
                v-model.number="product.uom" 
                style="max-width:100%;">
              <option disabled value="">{{ $anm22.strLang(lang, 'Select', 'Seleziona') }}</option>
              <option 
                  v-for="(obj,key,i) in $anm22.tableClasses.foodUnitOfMeasurement().getAll()"
                  :key="'prod-uof-'+i"
                  :value="key">
                {{ obj[lang] }}
              </option>
            </select>
          </div>
        </div>
        <div class="vertical-height-div" style="height:10px;"></div>
        <!-- Standard weight (if weight) -->
        <div class="wg-row">
          <div class="wg-col wg-xs-12 wg-sm-6" style="padding:0 5px 0 0;">
            <div class="com-anm22-app-text-l" style="padding:0 2px;">
              {{ $anm22.strLang(lang, 'Standard portion', 'Porzione standard') }}
            </div>
            <div class="vertical-height-div" style="height:5px;"></div>
            <input 
                style="max-width:100%;"
                type="number"
                :placeholder="$anm22.strLang(lang, 'Quantity', 'Quantità')"
                v-model="product.defaultQuantity">   
          </div>
        </div>
      </template>
      <div class="vertical-height-div" style="height:10px;"></div>
      <div class="wg-row">
        <div class="wg-col wg-xs-12 wg-sm-6" style="padding:0 5px 0 0;">
          <div class="com-anm22-app-text-l" style="padding:0 2px;">
            {{ $anm22.strLang(lang, 'Alarm threshold', 'Soglia notifica rimanenza') }}
          </div>
          <div class="vertical-height-div" style="height:5px;"></div>
          <input 
              style="max-width:100%;"
              type="number"
              :placeholder="$anm22.strLang(lang, 'Quantity', 'Quantità')"
              :value="product.quantityThreshold"
              @change="changeQuantity('quantityThreshold', $event.target.value)">  
        </div>
      </div>
    </template>
    <div class="vertical-height-div" style="height:10px;"></div>
    <div class="wg-row">
      <div class="wg-col wg-xs-12 wg-sm-6" style="padding:0 5px 0 0;">
        <div class="com-anm22-app-text-l" style="padding:0 2px;">
          {{ $anm22.strLang(lang, 'Product status', 'Stato prodotto') }}
        </div>
        <div class="vertical-height-div" style="height:5px;"></div>
        <select class="com-anm22-app-select" v-model="product.status" style="max-width:100%;">
          <option 
              v-for="(obj,key,i) in $anm22.tableClasses.foodProductStatus().getAll()"
              :key="'prod-status-'+i"
              :value="key">
            {{ obj[lang] }}
          </option>
        </select>
      </div>
    </div>
    <div class="vertical-height-div" style="height:10px;"></div>
    <div class="wg-row">
      <div class="wg-col wg-xs-12 wg-sm-6" style="padding:0 5px 0 0;">
        <div class="com-anm22-app-text-l" style="padding:0 2px;">
          {{ $anm22.strLang(lang, 'Visible by customers', 'Visibile ai clienti') }}
        </div>
        <div class="vertical-height-div" style="height:5px;"></div>
        <input 
            id="visibleByCustomer"
            type="checkbox"
            :value="0"
            style="display:none;"
            v-model="product.visibleByCustomer">
        <label class="label-input-radio" for="visibleByCustomer">
          {{ product.visibleByCustomer ? '✔' : '' }}
        </label>
      </div>
    </div>
    <div class="vertical-height-div" style="height:10px;"></div>
    <div v-if="!showOthers" class="wg-row">
      <input 
          type="button"
          :value="$anm22.strLang(lang, 'Show other fields', 'Mostra altro')" 
          @click="showOthers = true;">
    </div>
    <div v-else class="wg-row">
      <template v-for="(l,i) in languages">
        <div :key="'lang-s1-'+i" class="vertical-height-div" style="height:10px;"></div>
        <div :key="'lang-title-'+i" class="wg-row">
          <div class="com-anm22-app-text-l" style="padding:0 2px;">
            {{ l.toUpperCase() }}
          </div>
        </div>
        <div :key="'lang-s2-'+i" class="vertical-height-div" style="height:10px;"></div>
        <div :key="'lang-input-'+i" class="wg-row">
          <div class="wg-col wg-xs-12 wg-sm-6" style="padding:0 5px 0 0;">
            <div class="com-anm22-app-text-l" style="padding:0 2px;">
              {{ $anm22.strLang(lang, 'Name', 'Nome') }}
            </div>
            <div class="vertical-height-div" style="height:5px;"></div>
            <input 
                class="com-anm22-app-input-text"
                style="max-width:100%;"
                type="text"
                :placeholder="$anm22.strLang(lang, 'Name', 'Nome')"
                v-model="product['name'+$anm22.capitalizeFirst(l)]">   
          </div>
          <div class="wg-col wg-xs-12 wg-sm-6" style="padding:0 5px 0 0;">
            <div class="com-anm22-app-text-l" style="padding:0 2px;">
              {{ $anm22.strLang(lang, 'Description', 'Descrizione') }}
            </div>
            <div class="vertical-height-div" style="height:5px;"></div>
            <input 
                class="com-anm22-app-input-text"
                style="max-width:100%;"
                type="text"
                :placeholder="$anm22.strLang(lang, 'Description', 'Descrizione')"
                v-model="product['description'+$anm22.capitalizeFirst(l)]">   
          </div>
        </div>
      </template>
      <div class="vertical-height-div" style="height:10px;"></div>
      <div class="wg-row">
        <div class="wg-col wg-xs-12 wg-sm-6" style="padding:0 5px 0 0;">
          <div class="com-anm22-app-text-l" style="padding:0 2px;">
            {{ $anm22.strLang(lang, 'Manifacturer', 'Azienda produttrice') }}
          </div>
          <div class="vertical-height-div" style="height:5px;"></div>
          <input 
              class="com-anm22-app-input-text"
              style="max-width:100%;"
              type="text"
              :placeholder="$anm22.strLang(lang, 'Manifacturer', 'Azienda produttrice')"
              v-model="product.manifacturer">   
        </div>
      </div>
      <template v-if="license.config.modules.sequences.enabled">
        <div class="vertical-height-div" style="height:10px;"></div>
        <div class="wg-row">
          <div class="wg-col wg-xs-12 wg-sm-6" style="padding:0 5px 0 0;">
            <div class="com-anm22-app-text-l" style="padding:0 2px;">
              {{ $anm22.strLang(lang, 'Order printer', 'Stampa comande') }}
            </div>
            <div class="vertical-height-div" style="height:5px;"></div>
            <select class="com-anm22-app-select" v-model="product.idPrinter" style="max-width:100%;">
              <option default value="0">
                {{ $anm22.strLang(lang, 'As category', 'Come categoria') }}
              </option>
              <option 
                  v-for="(p,i) in printers"
                  :key="'printer-'+i"
                  :value="p.idPrinter">
                {{ p.name }}
              </option>
            </select>
          </div>
        </div>
      </template>
    </div>
    <div class="vertical-height-div" style="height:10px;"></div>
    <div class="wg-row">
      <input 
          type="button" 
          :value="$anm22.strLang(lang, 'Show inventory logs', 'Mostra movimenti inventario')" 
          @click="showInventoryLogs">
    </div>
    <div class="vertical-height-div" style="height:10px;"></div>
    <div class="wg-row">
      <input 
          type="button" 
          :value="$anm22.strLang(lang, 'Save', 'Salva')" 
          @click="save">
    </div>
    <div class="vertical-height-div" style="height:10px;"></div>
    <div class="wg-row">
      <input 
          type="button"
          class="com-anm22-button-red" 
          :value="$anm22.strLang(lang, 'Delete', 'Elimina')" 
          @click="deleteProduct">
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Anm22FileUploader from "../../../../../world/spa/components/Anm22FileUploaderInline.vue";
import WGList from '../../../../../world/spa/components/WGList.vue';

export default {
  components: {
    Anm22FileUploader,
    WGList
  },
  props: {
    productRef: Object,
    timezone: {
      type: String,
      default: 'Europe/Rome'
    }
  },
  data() {
    return {
      priceError: "",
      varError: "",
      uomError: "",
      showOthers: false,
      product: {...this.productRef},
      languages: ['it', 'en', 'de', 'fr', 'es', 'ru'],
      colors: [
        '#F4511E',
        '#E53935',
        '#D81B60',
        '#8E24AA',
        '#3949AB',
        '#2196f3',
        '#00897B',
        '#43A047',
        '#546E7A',
        '#000',
      ],
      icons: [],
      showVariationsDialog: false,
      variation: {},
      showIconDialog: false,
      icon: null,
      showConfirmDelete: false,
      showColorDialog: false,
      color: null,
      showInventoryLogsDialog: false,
      inventoryLogsLoading: false,
      inventoryLogEntries: null
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      lang: state => state.lang,
      licenseSelected: state => state.licenseSelected,
      windowWidth: state => state.windowWidth,
      windowHeight: state => state.windowHeight,
      isOffline: state => state.offline.isOffline
    }),
    modalHeight() {
      return Math.floor(this.windowHeight * 0.9 - 90);
    },
    listHeight() {
      return this.modalHeight - 70;
    },
    license() {
      return this.$store.getters['foodLicenses/getByHash'](this.licenseSelected);
    },
    categories() {
      return this.$store.getters['foodCategories/getByLicense'](this.license.id).filter(c => !c.deleted);
    },
    category() {
      return this.categories.find(c => c.id === this.productRef.category);
    },
    printers() {
      return this.$store.getters['foodPrinters/getByLicense'](this.license.id).filter(p => p.printMode.list);
    },
    entriesListHeader() {
      return [
        {
          field: 'ts',
          label: this.$anm22.strLang(this.lang, 'Date', 'Data'),
          class: 'wg-xs-4',
          disabled: false
        },
        {
          field: 'log',
          label: this.$anm22.strLang(this.lang, 'Source', 'Origine'),
          class: 'wg-xs-5',
          disabled: true,
        },
        {
          field: 'variation',
          label: this.$anm22.strLang(this.lang, 'Variation', 'Variazione'),
          class: 'wg-xs-3',
          style: { justifyContent: 'flex-end' },
          disabled: false,
        }
      ]
    },
    entriesListRows() {
      if(this.inventoryLogEntries) {
        return this.inventoryLogEntries.map(e => {
          return {
            id: e.id,
            ts: e.ts,
            log: e.log,
            variation: e.variation,
            uom: e.productUom,
            'list-metadata': {
              type: 'item',
            }
          }
        });
      } else {
        return [];
      }
    }
  },
  methods: {
    changeQuantity(field, val) {
      let value = Number(val);
      if(value < 0) {
        value = 0;
      }
      if(this.product.stockType !== 3 && !Number.isInteger(value)) {
        value = Math.floor(value);
      }
      this.product[field] = value;
    },
    async save() {
      if(!this.product.price && this.product.price !== 0){
        //Mostro errore e impedisco il salvataggio
        this.priceError = this.$anm22.strLang(
          this.lang,
          "Product price not valid",
          "Prezzo del prodotto non è valido"
        );
        return;
      }
      // Verifiy price is >= 0
      if(this.product.price < 0){
        //Mostro errore e impedisco il salvataggio
        this.priceError = this.$anm22.strLang(
          this.lang,
          "Product price cannot be negative",
          "Il prezzo del prodotto non può essere negativo"
        );
        return;
      }
      // if(this.product.variations.length > 0) {
      //   for (let i = 0; i < this.product.variations.length; i++) {
      //     const v = this.product.variations[i];
      //     if(v.price < 0) {
      //       this.varError = this.$anm22.strLang(
      //         this.lang,
      //         "Variation price cannot be negative",
      //         "Il prezzo della variazione non può essere negativo"
      //       );
      //       return;
      //     }
      //   }
      // }
      if((this.product.pricingType === 2 || this.product.stockType === 3) && !this.product.uom) {
        this.uomError = this.$anm22.strLang(
          this.lang,
          "Choose a unit of measurement",
          "Selezionare un'unità di misura"
        );
        return;
      }
      const mode = Number.isInteger(this.product.id) ? 'edit' : 'new';
      try {
        const response = await this.$http.post('inventory/product', {
          product: this.product
        });
        this.$store.dispatch('foodProducts/update', {
          vlf: this.$vlf('foodProducts'), objs: response.data.products
        })
      } catch(e) {
        const category = this.categories.find(c => c.id === this.product.category);
        // Dati aggregati o derivati
        this.product.langName = this.product['name' + this.lang] || this.product.name;
        this.product.langDescription = this.product['description' + this.lang] || this.product.description;
        this.product.img = category.img;
        this.product.icon = this.product.iconName ? 'utilities/img/gastronomy-white-svg/' + this.product.iconName + '.svg' : category.icon;
        this.product.color = this.product.colorString || category.color;
        await Promise.all([
          this.$store.dispatch('foodProducts/update', {
            vlf: this.$vlf('foodProducts'), objs: [ this.product ]
          }),
          this.$store.dispatch('offline/saveSyncTuple', {
            _vue: this,
            _class: "FoodProduct",
            _table: "foodProducts",
            mode: mode,
            type: 'obj',
            obj: this.product
          })
        ]);
      } finally {
        this.$anm22.eventBus.$emit('wg-modal-close');
      }
    },
    async deleteProduct() {
      try {
        if(!Number.isInteger(this.product.id)) {
          throw new Error('Local object');
        }
        const response = await this.$http.post('inventory/product-delete', {
          product: this.product
        });
        if(response.data.success) {
          this.product.deleted = true;
          this.$store.dispatch('foodProducts/update', {
            vlf: this.$vlf('foodProducts'), objs: [this.product]
          });
        } else {}
      } catch(e) {
        this.product.deleted = true;
        await Promise.all([
          this.$store.dispatch('foodProducts/update', {
            vlf: this.$vlf('foodProducts'), objs: [ this.product ]
          }),
          this.$store.dispatch('offline/saveSyncTuple', {
            _vue: this,
            _class: "FoodProduct",
            _table: "foodProducts",
            mode: 'edit',
            type: 'obj',
            obj: this.product
          })
        ]);
      } finally {
        this.$anm22.eventBus.$emit('wg-modal-close');
      }
    },
    async addVariation() {
      this.varError = '';
      if(!this.variation.it && !this.variation.en && !this.variation.de && !this.variation.fr
            && !this.variation.es && !this.variation.ru
      ) {
        this.varError = this.$anm22.strLang(
          this.lang,
          "At least one language must be provided",
          "Almeno una lingua deve essere compilata"
        );
        return;
      }
      if(!this.variation.price && this.variation.price !== 0) {
        this.varError = this.$anm22.strLang(
          this.lang,
          "Variation price not valid",
          "Prezzo della variazione non valido"
        );
        return;
      }
      // if(this.variation.price < 0) {
      //   this.varError = this.$anm22.strLang(
      //     this.lang,
      //     "Variation price cannot be negative",
      //     "Il prezzo della variazione non può essere negativo"
      //   );
      //   return;
      // }
      try {
        if(!Number.isInteger(this.productRef.id)) {
          throw new Error('Local object');
        }
        const response = await this.$http.post('inventory/add-var', {
          productId: this.productRef.id,
          variation: this.variation
        });
        this.$store.dispatch('foodProducts/update', {
          vlf: this.$vlf('foodProducts'), objs: response.data.products
        });
      } catch(e) {
        this.product.variations.push(JSON.parse(JSON.stringify(this.variation)));
        this.$store.dispatch('foodProducts/update', {
          vlf: this.$vlf('foodProducts'), objs: [ this.product ]
        }),
        this.$store.dispatch('offline/saveSyncTuple', {
          _vue: this,
          _class: "FoodProduct",
          _table: "foodProducts",
          mode: 'edit',
          type: 'obj',
          obj: this.product
        })
      } finally {
        this.variation = {};
      }
    },
    async deleteVariation(index) {
      try {
        if(!Number.isInteger(this.productRef.id)) {
          throw new Error('Local object');
        }
        const response = await this.$http.post('inventory/delete-var', {
          productId: this.productRef.id,
          index
        });
        this.$store.dispatch('foodProducts/update', {
          vlf: this.$vlf('foodProducts'), objs: response.data.products
        });
      } catch(e) {
        this.product.variations.splice(index, 1);
        this.$store.dispatch('foodProducts/update', {
          vlf: this.$vlf('foodProducts'), objs: [ this.product ]
        }),
        this.$store.dispatch('offline/saveSyncTuple', {
          _vue: this,
          _class: "FoodProduct",
          _table: "foodProducts",
          mode: 'edit',
          type: 'obj',
          obj: this.product
        })
      }
    },
    openIconModal() {
      // Load icons if not loaded
      if(this.icons.length === 0) {
        this.$http.get('inventory/icons')
          .then(response => {
            this.icons = response.data.icons;
          });
      }
      if(this.product.iconName) {
        this.icon = this.product.iconName;
      }
      this.showIconDialog = true;
    },
    async setIcon(name) {
      this.icon = name;
      try {
        if(!Number.isInteger(this.productRef.id)) {
          throw new Error('Local object');
        }
        const response = await this.$http.post('inventory/icons', {
          productId: this.productRef.id,
          icon: this.icon
        });
        this.$store.dispatch('foodProducts/update', {
          vlf: this.$vlf('foodProducts'), objs: response.data.products
        });
      } catch(e) {
        this.product.iconName = this.icon;
        this.$store.dispatch('foodProducts/update', {
          vlf: this.$vlf('foodProducts'), objs: [ this.product ]
        }),
        this.$store.dispatch('offline/saveSyncTuple', {
          _vue: this,
          _class: "FoodProduct",
          _table: "foodProducts",
          mode: 'edit',
          type: 'obj',
          obj: this.product
        })
      }
    },
    async setImage(data) {
      const response = await this.$http.post('inventory/set-image', {
        productId: this.product.id,
        image: data.url
      });
      this.$store.dispatch('foodProducts/update', {
        vlf: this.$vlf('foodProducts'), objs: response.data.products
      });
    },
    async deleteImage() {
      const response = await this.$http.post('inventory/delete-image', {
        productId: this.product.id
      });
      this.$store.dispatch('foodProducts/update', {
        vlf: this.$vlf('foodProducts'), objs: response.data.products
      });
      this.showConfirmDelete = false;
    },
    openColorModal() {
      if(this.productRef.colorString) {
        this.color = this.productRef.colorString;
      }
      this.showColorDialog = true;
    },
    async setColor() {
      try {
        if(!Number.isInteger(this.productRef.id)) {
          throw new Error('Local object');
        }
        const response = await this.$http.post('inventory/color', {
          productId: this.productRef.id,
          color: this.color
        });
        this.$store.dispatch('foodProducts/update', {
          vlf: this.$vlf('foodProducts'), objs: response.data.products
        });
      } catch(e) {
        this.product.colorString = this.color;
        this.$store.dispatch('foodProducts/update', {
          vlf: this.$vlf('foodProducts'), objs: [ this.product ]
        }),
        this.$store.dispatch('offline/saveSyncTuple', {
          _vue: this,
          _class: "FoodProduct",
          _table: "foodProducts",
          mode: 'edit',
          type: 'obj',
          obj: this.product
        })
      } finally {
        this.showColorDialog = false;
      }
    },
    async showInventoryLogs() {
      this.inventoryLogsLoading = true;
      this.showInventoryLogsDialog = true;
      try {
        const response = await this.$http.get('inventory/product-logs', {
          params: {
            productId: this.productRef.id
          }
        });
        this.inventoryLogEntries = response.data.entries;
      } catch(e) {
        this.inventoryLogEntries = null;
      } finally {
        this.inventoryLogsLoading = false;
      }
    },
    getUom(e) {
      if(e.uom) {
        return this.$anm22.tableClasses.foodUnitOfMeasurement().getById(e.uom)['typeClassLiteral'];
      } else {
        return this.$anm22.strLang(this.lang, 'pc.', 'pz.');
      }
    },
  },
  watch: {
    productRef(newVal, old) {
      this.product = { ...this.productRef };
    }
  }
}
</script>

<style lang="scss" scoped>
input.error {
  background-color: red;
  color: #fff;
}
.label-input-radio {
  display: block;
  height: 30px;
  width: 30px;
  border: 1px solid #bbb;
  border-radius: 4px;
  font-size: 18px;
  padding: 6px;
  cursor: pointer;
}
.icon-div {
  border: 3px solid #ddd;
  background-position: center center;
  background-size: cover;
  cursor: pointer;
  border-radius: 5px;
  background-color: #fff;
  padding: 5px;
  box-sizing: border-box;
  margin: 5px;
  &:hover, &.selected {
    border-color: #2196F3;
  }
}
.color-div {
  border-radius: 5px;
  justify-content: center;
  cursor: pointer;
  margin-bottom: 10px;
  &:hover, &.selected {
    background-color: #ddd;
  }
  div {
    height: 15px;
    width: 60px;
    margin: 10px 0;
    border-radius: 10px;
    border: 1px solid #ccc;
  }
}
.custom-img {
  padding:0;
  object-fit: cover;
  object-position: center;
}
.item-row {
  height: 36px;
  &:hover {
    background-color: #eee;
  }
}
</style>
